export const LOCAL_STORAGE_SHOW_ONBOARDING_CONTAINER =
  'show-onboarding-container'
